// only the token that is used to fetch the config API
const getTokenFromUrl = (): string => {
    const url = window.location.href;
    const token = url.match(/token=(.*?)&name/i);
    if (token) {
        return token[1];
    }
    return "";
};

export function setHeader(config: any){
    const authToken = localStorage.getItem('accessToken');
    config.headers['X-AUTH-TOKEN']  = authToken ? authToken : `_${getTokenFromUrl()}`;
}

